<template>
  <div class="sb-navigation">
    <div class="position-relative py-3">
      <div
        class="navigation-group"
        v-for="(nav, nav_idx) in tcfd_contents"
        :key="`navigation-group-${nav_idx}-${nav.category_code}`"
      >
        <div :class="['d-flex align-items-center mb-3 pl-3', { 'mt-4': nav_idx !== 0 }]">
          <h5
            class="nav-title nav-title--parent"
            :data-observe-anchor="'rp' + nav.category_code"
            :class="{
              'navigation-indicator': nav_idx === 0,
            }"
          >
            <b-link
              class="nav-anchor text-keep-all text-decoration-none"
              @click="scroll_to_title('rp' + nav.category_code)"
            >
              <span v-show="lang === 'KOR'">{{ nav.category_name }}</span>
              <span v-show="lang === 'ENG'">{{ nav.category_name_e }}</span>
            </b-link>
          </h5>
        </div>

        <h6
          v-for="(subtopic, subtopic_idx) in nav.indicators"
          :key="'g' + subtopic_idx"
          :class="['nav-title nav-title--child', 'mb-0', 'ml-3']"
          :data-observe-anchor="'w' + subtopic.tcfd_code"
        >
          <b-link
            class="nav-anchor text-keep-all text-decoration-none"
            @click="scroll_to_title('w' + subtopic.tcfd_code)"
          >
            <span v-show="lang === 'KOR'">
              {{ subtopic.tcfd_code }}
            </span>
            <span v-show="lang === 'ENG'">{{ subtopic.tcfd_code }}</span>
          </b-link>
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: 'TCFDTocViewer',
    computed: {
      ...mapGetters('story_board', ['selected_lv2']),
      ...mapState('report_contents', ['tcfd_contents']),
      ...mapState('report_list', ['lang']),
      ...mapGetters('report_list', ['selected_report']),
      anchorList() {
        return this.tcfd_contents.reduce((_anchors, navEle) => {
          if (navEle?.category_code) {
            _anchors.push(`#rp${navEle.category_code}`);
          }
          if (navEle?.indicators && navEle.indicators.length) {
            navEle.indicators.forEach((subtopic) => {
              _anchors.push(`#w${subtopic.tcfd_code}`);
            });
          }
          return _anchors;
        }, []);
      },
    },
    mounted() {
      setTimeout(() => {
        this.anchorObserver = new IntersectionObserver(this.handlerObserveAnchor, {
          rootMargin: '0% 0% -78.5% 0%',
          threshold: 0.1,
        });
        this.anchorList.forEach((_anchor) => {
          const _anchorTitle = document.querySelector(_anchor);
          if (_anchorTitle && _anchorTitle.childElementCount > 0) {
            this.anchorObserver.observe(_anchorTitle);
          }
        });
        const initialNav = document.querySelector('.navigation-indicator');
        if (initialNav) {
          initialNav.style.color = this.selected_report.main_color;
          initialNav.style.borderLeft = `4px solid ${this.selected_report.main_color}`;
        }
      }, 400);
    },
    data() {
      return {
        nchorObserver: null,
      };
    },
    methods: {
      handlerObserveAnchor(entries) {
        if (entries.length) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const _navToAnchor = document.querySelectorAll(
                `[data-observe-anchor="${entry.target.id.replace(/#/g, '')}"]`
              );
              if (_navToAnchor.length) {
                const _activedNavs = document.querySelectorAll('.navigation-indicator');
                if (_activedNavs.length) {
                  _activedNavs.forEach((_activedNav) => {
                    _activedNav.classList.remove('navigation-indicator');
                    _activedNav.style.color = '';
                    _activedNav.style.borderLeft = '';
                  });
                }
                this.activatedAnchor = entry.target.id.replace(/#/g, '');
                _navToAnchor[0].childNodes[0].classList.add('navigation-indicator');
                _navToAnchor[0].childNodes[0].style.color = this.selected_report.main_color;
                _navToAnchor[0].childNodes[0].style.borderLeft = `4px solid ${this.selected_report.main_color}`;
              }
            }
          });
        }
      },
      scroll_to_title(link) {
        const element = document.getElementById(link);
        if (element) {
          element.style.scrollMarginTop = '100px';
          element.scrollIntoView({ behavior: 'smooth' });
        }
      },
    },
  };
</script>

<style>
</style>
